import React from "react";
import PropTypes from "prop-types";
import withGenderFilter from "theme/components/helpers/withGenderFilter";
import { compose } from "recompose";
import WysiwygV2 from "theme/modules/WysiwygV2";

const GenderContent = ({
  currentGender,
  gender_content_men_slippers,
  gender_content_men_socks,
  gender_content_women_slippers,
  gender_content_women_socks,
  gender_content_women_tights,
  gender_content_kids_slippers,
  gender_content_kids_socks,
  gender_content_kids_tights,
  meta_title,
}) => {
  const getProductType = (title) => {
    if (!title) return null;
    const types = {
      slippers: ["Chaussons", "Haussocken", "Slippers", "Babbucce"],
      socks: ["Chaussettes", "Strümpfe und Socken", "Socks", "Calze"],
      tights: ["collants", "Strumpfhosen", "Tights", "Collant"],
    };

    for (const [type, keywords] of Object.entries(types)) {
      if (keywords.some((keyword) => title.includes(keyword))) {
        return type;
      }
    }
    return null;
  };

  const genderContents = {
    299: {
      // men
      slippers: gender_content_men_slippers,
      socks: gender_content_men_socks,
    },
    300: {
      // women
      slippers: gender_content_women_slippers,
      socks: gender_content_women_socks,
      tights: gender_content_women_tights,
    },
    301: {
      // kids
      slippers: gender_content_kids_slippers,
      socks: gender_content_kids_socks,
      tights: gender_content_kids_tights,
    },
  };

  const productType = getProductType(meta_title);
  const content =
    productType && genderContents[currentGender]?.[productType]?.contentWysiwyg;

  if (!content) return null;

  return (
    <div className="gender-content">
      <WysiwygV2 content={content} />
    </div>
  );
};

GenderContent.propTypes = {
  currentGender: PropTypes.number,
  gender_content_men_slippers: PropTypes.object,
  gender_content_men_socks: PropTypes.object,
  gender_content_women_slippers: PropTypes.object,
  gender_content_women_socks: PropTypes.object,
  gender_content_women_tights: PropTypes.object,
  gender_content_kids_slippers: PropTypes.object,
  gender_content_kids_socks: PropTypes.object,
  gender_content_kids_tights: PropTypes.object,
  meta_title: PropTypes.string,
};

export default compose(withGenderFilter())(GenderContent);
